import * as React from 'react';
import DashboardCardHeader from './CardHeader';
import { Col, Grid } from 'lib/grid';
import { Button } from '@salesforce/design-system-react';
import { NavigationProps } from 'lib/types';

const GetStartedCard: React.SFC<NavigationProps> = ({navClick}) => (
	<Col className="dashboard_get-started">
		<DashboardCardHeader
			icon="trail"
			iconCategory="utility"
			showHelp
			subtext="Choose an integration guide to enable common use cases"
			title="Get Started"
		/>
		<Grid className="dashboard_guide-card">
			<Col>
				<h4 className="slds-text-title_caps">Multi-Organization Guide</h4>
				<p className="slds-text-heading_small">Enable Worldwide Service</p>
			</Col>
			<Col><Button className="slds-float_right" label="Get Started" /></Col>
		</Grid>
		<Grid className="dashboard_guide-card">
			<Col>
				<h4 className="slds-text-title_caps">Retail Guide</h4>
				<p className="slds-text-heading_small">Enable Commerce Journeys</p>
			</Col>
			<Col><Button className="slds-float_right" label="Get Started" /></Col>
		</Grid>
		<Grid className="dashboard_guide-card">
			<Col>
				<h4 className="slds-text-title_caps">Healthcare Guide</h4>
				<p className="slds-text-heading_small">Enable Health Communities</p>
			</Col>
			<Col><Button className="slds-float_right" label="Get Started" /></Col>
		</Grid>
		<a className="dashboard_see-all-link" onClick={navClick}>See All Guides</a>
	</Col>
);

export default GetStartedCard;


// WEBPACK FOOTER //
// ./src/Dashboard/GetStartedCard.tsx